import type { Rule } from 'antd/lib/form';

import { transformEmojisIfHave } from '@/helpers/string.helper';

import { PASSWORD_PATTERN } from './regex.constants';
import { LABEL_PREVIEW_MESSAGES } from './tagfont.constants';

type ValidationErrorLabel = 'overMaxLength' | 'notMatchRule';

const MAX_QUANTITY_NUMBER = 9999;
const MAX_INTEGER_NUMBER = 2_147_483_647;
const MAX_QUANTITY_AND_PRICE = 1_000_000;
const MAX_BILLING_AMOUNT_NUMBER = 1_000_000_000;

const PASSWORD_VALIDATION_RULES: Rule[] = [
  {
    pattern: PASSWORD_PATTERN,
    message: '英大文字小文字、数字の組み合わせで8桁以上で設定してください。',
  },
  { required: true, whitespace: true },
  {
    min: 8,
    transform(value) {
      return transformEmojisIfHave(value);
    },
  },
  {
    max: 99,
    transform(value) {
      return transformEmojisIfHave(value);
    },
  },
];

const customizeLabelInputValidation = (key: string) => ({
  validator() {
    const currentLabelInputValidation = JSON.parse(
      document.body.dataset.validation || '{}',
    );
    if (currentLabelInputValidation[key])
      return Promise.reject(
        new Error(
          LABEL_PREVIEW_MESSAGES[
            currentLabelInputValidation[key] as ValidationErrorLabel
          ],
        ),
      );
    return Promise.resolve();
  },
});

const FORM_ITEM_LAYOUT_COMMON = {
  labelCol: { span: 7 },
  wrapperCol: { span: 12 },
} as const;

const FORM_ITEM_LAYOUT_SMALL_CONTENT = {
  labelCol: { span: 7 },
  wrapperCol: { span: 7 },
} as const;

const FORM_ITEM_LAYOUT_WITH_CHECKBOX = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },
} as const;

const FORM_ITEM_LAYOUT_AUTH = {
  labelCol: { span: 9 },
  wrapperCol: { span: 15 },
} as const;

const FORM_ITEM_LAYOUT_FULL_LABEL = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
} as const;

const FORM_ITEM_LAYOUT_FULL_LABEL_WITH_PICKER = {
  labelCol: { span: 24 },
  wrapperCol: { span: 12 },
} as const;

export {
  customizeLabelInputValidation,
  FORM_ITEM_LAYOUT_AUTH,
  FORM_ITEM_LAYOUT_COMMON,
  FORM_ITEM_LAYOUT_FULL_LABEL,
  FORM_ITEM_LAYOUT_FULL_LABEL_WITH_PICKER,
  FORM_ITEM_LAYOUT_SMALL_CONTENT,
  FORM_ITEM_LAYOUT_WITH_CHECKBOX,
  MAX_BILLING_AMOUNT_NUMBER,
  MAX_INTEGER_NUMBER,
  MAX_QUANTITY_AND_PRICE,
  MAX_QUANTITY_NUMBER,
  PASSWORD_VALIDATION_RULES,
};
